import {
    Component,
    ViewChild,
    Injector,
    Output,
    EventEmitter,
    OnInit,
    ElementRef,
    ViewChildren,
    QueryList,
} from '@angular/core';
import { finalize } from 'rxjs/operators';
import {
    CommonLookupServiceProxy,
    AddStockServiceProxy,
    CreateOrEditAddStockDto,
    DropDownLookupDto,
    FindProductOutputDto,
    TaxDto,
    Status,
    CreateOrEditAddStockDetailDto,
    GetAddStockForEditInput,
    CreateOrEditProductionDetailDto,
    RetailPlanServiceProxy,
    CreateOrEditProductionDto,
    CreateOrEditProductionRawMaterialDetailDto,
    ProductionServiceProxy,
    CreateOrEditProductionInput,
    GetProductionForInput,
    ProductionRawMaterialDto
} from '@shared/service-proxies/service-proxies';
import { AppComponentBase } from '@shared/common/app-component-base';
import { DateTime } from 'luxon';
import { ActivatedRoute, Router } from '@angular/router';
import { appModuleAnimation } from '@shared/animations/routerTransition';
import { Observable } from '@node_modules/rxjs';
import { BreadcrumbItem, SubHeaderComponent } from '@app/shared/common/sub-header/sub-header.component';

import { DateTimeService } from '@app/shared/common/timing/date-time.service';

import { AutoCompleteCompleteEvent, AutoCompleteModule } from 'primeng/autocomplete';
import { debug } from 'console';
import { forEach } from 'lodash-es';

@Component({
    templateUrl: './create-or-edit-production.component.html',
    animations: [appModuleAnimation()],
    standalone: false,
})
export class CreateOrEditProductionComponent extends AppComponentBase implements OnInit {
    active = false;
    saving = false;
    productSelectedItem: FindProductOutputDto;
    productionProducts: DropDownLookupDto[];
    applicableTaxes: TaxDto[];
    units: any[] = [];

    filterText = '';
    totalQty = 0;
    production: CreateOrEditProductionDto = new CreateOrEditProductionDto();
    productproductionDetails: CreateOrEditProductionDetailDto[];
    productproductionDetail: CreateOrEditProductionDetailDto = new CreateOrEditProductionDetailDto();

    productionRawMaterialDetails: CreateOrEditProductionRawMaterialDetailDto[];
    productRawMaterials: ProductionRawMaterialDto[];
  
    status = Status;
    breadcrumbs: BreadcrumbItem[] = [
        new BreadcrumbItem(this.l('Productions'), '/app/stock/productions'),
        new BreadcrumbItem(this.l('Entity_Name_Plural_Here') + '' + this.l('Details')),
    ];

    constructor(
        injector: Injector,
        private _activatedRoute: ActivatedRoute,
        private _productionServiceProxy: ProductionServiceProxy,
        private _commonLookupServiceProxy: CommonLookupServiceProxy,
        private _retailPlanServiceProxy: RetailPlanServiceProxy,
        private _router: Router,
        private _dateTimeService: DateTimeService,

    ) {
        super(injector);
    }

    ngOnInit(): void {
        this.productRawMaterials = [];
        this.show(this._activatedRoute.snapshot.queryParams['id']);
        this.addRow(0);
    }

    removeItem(index: number) {
        this.productproductionDetails.splice(index, 1);

        if (this.productproductionDetails.length == 0) {
            this.addRow(index);
        }

        var i = 1;
        this.productproductionDetails.forEach((c) => {
            c.slNo = i++;
        });

        this.productSelectedItem = null;
    }

    addRow(index: number): void {
        if (this.productproductionDetails == null) this.productproductionDetails = [];

        this.productproductionDetail = new CreateOrEditProductionDetailDto();
        this.productproductionDetail.slNo = this.productproductionDetails.length + 1;
        this.productproductionDetails.push(this.productproductionDetail);
      
    }

    changeUnit(data: any): void {
        data.changeUnitFlag = true;
        this.fillDropDownUnitBasedOnProduct(data.productId, data);
    }

    fillDropDownUnitBasedOnProduct(selectProductId: number, data: CreateOrEditAddStockDetailDto): void {
       
        this._commonLookupServiceProxy.getUnitForProductCombobox(selectProductId).subscribe({
            next: (result: any) => {
               
                if (!(data.unitId > 0 && data.qty > 0)) {
                    data.unitId = data.unitId;
                    data.unitName = data.unitName;
                }
                this.amountCalculate(data);
                this.calculateTotalValues();
            },
            error: () => { },
        });
    }

    show(productionId?: number): void {
        if (!productionId) {
            this.production = new CreateOrEditProductionDto();
            this.production.id = productionId;

            this.production.productionDate = this._dateTimeService.getStartOfDay();
            this.active = true;
            this.production.locationId = this.appSession.user.locationId;
            this.production.status = Status.Draft;
        } else {
            this._productionServiceProxy.getProductionForEdit(productionId).subscribe((result) => {
                this.production = result.production;
                this.productproductionDetails = result.productionDetail;
                this.productionRawMaterialDetails = result.productionRawMaterialDetail;
               
                this.productRawMaterials = [];
               
                this.productionRawMaterialDetails.forEach(value => {
                    var rawMaterialDto = new ProductionRawMaterialDto();
                    rawMaterialDto.id = value.id;
                    rawMaterialDto.productId = value.productId;
                    rawMaterialDto.productCode = value.productCode;
                    rawMaterialDto.productName = value.productName;
                    rawMaterialDto.qty = value.qty;
                    rawMaterialDto.unitId = value.unitId;
                    rawMaterialDto.averageCost = value.averageCost;
                    rawMaterialDto.varianceQty = value.varianceQty;
                    rawMaterialDto.availableQty = value.availableQty;
                    this.productRawMaterials.push(rawMaterialDto);
                });

                this.calculateTotalValues();

                this.active = true;

                if (this._activatedRoute.snapshot.queryParams['dirinv'] == 0) {
                    this.production.id = null;
                    this.production.status = this.status.Draft;
                }
            });
        }

        this._commonLookupServiceProxy.getAllProductionProductsForTableDropdown().subscribe((result) => {
            this.productionProducts = result;
        });
    }



    amountCalculate(data: CreateOrEditAddStockDetailDto) {
        this.getRawMaterialItems();
    }



    save(status: any): void {
        this.saving = true;

        this.production.locationId = this.appSession.user.locationId;
        this.production.status = status;
        var productionInput = new CreateOrEditProductionInput();
        productionInput.production = this.production;
        productionInput.productionDetail = this.productproductionDetails;
        
        this.productionRawMaterialDetails = [];
        var i = 1;

        this.productRawMaterials.forEach(value => {
            var rawMaterialDto = new CreateOrEditProductionRawMaterialDetailDto();
            rawMaterialDto.productId = value.productId;
            rawMaterialDto.productCode = value.productCode;
            rawMaterialDto.qty = value.qty;
            rawMaterialDto.unitId = value.unitId;
            rawMaterialDto.averageCost = value.averageCost;
            rawMaterialDto.varianceQty = value.varianceQty;
            rawMaterialDto.availableQty = value.availableQty;
            this.productionRawMaterialDetails.push(rawMaterialDto);
        });

        productionInput.productionRawMaterialDetail = this.productionRawMaterialDetails;
        
        this._productionServiceProxy
            .createOrEditProduction(productionInput)
            .pipe(
                finalize(() => {
                    this.saving = false;
                }),
            )
            .subscribe((x) => {
                this.saving = false;
                this.notify.info(this.l('SavedSuccessfully'));
                this.goBack();
            });
    }

    getProductionProduct(value: any, productCode: any, productionDetail: CreateOrEditProductionDetailDto, index: number) {
        var productid = value.target.value;
        if (productCode != null) {
            productid = 0;
        }
        this._retailPlanServiceProxy.getProductsSimpleForInventoryCode(productid, productCode, this.appSession.user.locationId).subscribe((result) => {

            if (result.productId > 0) {
                productionDetail.productCode = result.productCode;
                productionDetail.unitName = result.unitName;
                productionDetail.productId = result.productId;
                productionDetail.qtyOnHand = result.qtyOnHand;
                productionDetail.unitId = result.unitId;
                productionDetail.qty = result.productionQty;
                this.getRawMaterialItems();
            } else {
                abp.notify.error('ProductNotFound');
                productionDetail.productCode = '';
            }
           
        });
    }

    getRawMaterialItems() { 

        let input: GetProductionForInput[] = [];
        this.productproductionDetails.forEach(c => {

            let data = new GetProductionForInput();
            data.productId = c.productId;
            data.qty = c.qty;
            input.push(data);
        });

       
        this._productionServiceProxy.getProductRawMaterials(input, this.appSession.user.locationId).subscribe((result) => {
            this.productRawMaterials = result;
            this.productRawMaterials.forEach(c => {
                c.availableQty = c.qty;
                c.varianceQty = c.qty - c.availableQty;
            });
            this.calculateTotalValues();
        });

    }

    calculateTotalValues(): void {

        var tempTotQty = 0;
        var tempTotAvailableQty = 0;

        this.productRawMaterials.forEach(val => {
            tempTotQty = Number(tempTotQty) + Number(val.qty);
            tempTotAvailableQty = Number(tempTotAvailableQty) + Number(val.availableQty);
            val.varianceQty = Number(val.qty) - Number(val.availableQty);
        });
        //vm.production.productionInputQty = parseFloat(tempTotQty).toFixed(3);
        this.production.productionInputQty = tempTotAvailableQty;
        this.production.productionVarianceQty = tempTotQty - tempTotAvailableQty;
        this.totalQty = Number(tempTotQty);

        //Production Detail Total
        tempTotQty = 0;
        this.productproductionDetails.forEach(val => {
           
            tempTotQty = Number(tempTotQty) + Number(val.qty);
        });

        this.production.productionQty = tempTotQty;

       
    }

    goBack(): void {
        this._router.navigate(['/app/stock/productions']);
    }
}
